import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCibWhenIWork = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_7498_8877)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M15 30C6.67969 30 0 23.2275 0 15C0 6.67969 6.67969 0 15 0C23.3203 0 30 6.67969 30 15C30 23.2275 23.3203 30 15 30ZM15 2.52C8.13 2.52 2.51437 8.13 2.51437 15.0009C2.51437 21.8719 8.13 27.4866 15 27.4866C21.87 27.4866 27.4856 21.8709 27.4856 15.0009C27.4856 8.13094 21.87 2.52 15 2.52ZM22.3584 16.4503H11.5181C11.2884 16.4516 11.0676 16.3618 10.9039 16.2007C10.7401 16.0397 10.6468 15.8203 10.6444 15.5906V14.3259C10.6444 13.8375 11.0297 13.4522 11.5181 13.4522H22.4503C22.9341 13.4522 23.3194 13.8431 23.3194 14.3259V15.5813C23.2266 16.065 22.8356 16.4503 22.3575 16.4503H22.3584ZM19.5506 11.6109H8.61281C8.38298 11.6127 8.16185 11.5231 7.99802 11.3619C7.83418 11.2007 7.74104 10.9811 7.73906 10.7513V9.48656C7.73906 9.09563 8.13 8.71031 8.61281 8.71031H19.545C19.9359 8.71031 20.3213 9.10125 20.3213 9.48656V10.7419C20.3213 11.2256 19.9369 11.6109 19.5506 11.6109ZM8.61375 18.3891H19.5516C20.0353 18.3891 20.4206 18.7744 20.4206 19.2581V20.5134C20.4211 20.7437 20.3305 20.9648 20.1686 21.1285C20.0066 21.2922 19.7865 21.3852 19.5563 21.3872H8.61375C8.13 21.2897 7.74469 20.9034 7.74469 20.4206V19.1606C7.74 18.7753 8.13 18.3891 8.61375 18.3891Z",
			fill: "#79C912"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7498_8877",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 30,
			height: 30,
			fill: "white"
		})
	}) })]
});
export default SvgCibWhenIWork;
